import React from 'react'
import { Link } from 'react-router-dom'
import "./notfound.css"

function NotFound() {
  return (
    <main className="notfound-page">
      <div className="notfound-card">
        <h1 className="notfound-code">404</h1>
        <h2 className="notfound-title">Page not found</h2>
        <p className="notfound-text">
          The page you are looking for doesn’t exist or was moved.
        </p>

        <Link to="/login" className="notfound-button">
          Go back home
        </Link>
      </div>
    </main>
  )
}

export default NotFound